export default "__VITE_ASSET__430fad61__"